import React, { useState, useEffect } from "react";
import "../Styles/MMGCheckout.css"; // ✅ External CSS
import qrCodeImage from "../assets/qr-code.png"; // ✅ Adjust the file name as needed

const MMGCheckout = () => {
  const cart = JSON.parse(localStorage.getItem("rcs_cart") || "[]");
  const totalAmount = cart.reduce((sum, item) => sum + (item.price || 0), 0);

  const [referenceId, setReferenceId] = useState("");
  const [paymentConfirmed, setPaymentConfirmed] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);

  useEffect(() => {
    const now = new Date();
    const id = `RCS-${now.getFullYear()}${(now.getMonth() + 1)
      .toString()
      .padStart(2, "0")}${now.getDate().toString().padStart(2, "0")}-${Math.floor(Math.random() * 1000)}`;
    setReferenceId(id);
  }, []);

  const handlePaymentConfirmation = () => {
    localStorage.removeItem("rcs_cart");
    setPaymentConfirmed(true);
  };

  const handleFileChange = (e) => {
    setUploadedFile(e.target.files[0]);
  };

  if (paymentConfirmed) {
    return (
      <div className="mmg-checkout-page">
        <h2 className="mmg-title">✅ Payment Submitted!</h2>
        <p className="mmg-center-text">
          Thank you for your payment. We will verify and process your order shortly.
        </p>
      </div>
    );
  }

  return (
    <div className="mmg-checkout-page">
      <h2 className="mmg-title">📲 Complete Your Payment with MMG</h2>

      <div className="checkout-box">
        <h4>🛍️ Your Items</h4>
        <ul className="item-list">
          {cart.map((item, i) => (
            <li key={i}>
              {item.name} - ${item.price.toLocaleString()}
            </li>
          ))}
        </ul>

        <hr />

        <p><strong>Total Amount:</strong> ${totalAmount.toLocaleString()}</p>

        <div className="payment-instructions">
          <h4>📋 Payment Instructions:</h4>
          <ol className="instruction-list">
            <li>Open your <strong>MMG App</strong> or <a href="https://mymm.gy" target="_blank" rel="noreferrer">mymm.gy</a></li>
            <li>Choose <strong>Pay Merchant</strong></li>
            <li>Merchant Name: <strong>Rc's Top-Up & Billing Entity</strong></li>
            <li>Merchant Code: <strong>m871937</strong> or Number: <strong>6627987</strong></li>
            <li>Amount: <strong>${totalAmount.toLocaleString()} GYD</strong></li>
            <li>Reference (Notes Section): <strong>{referenceId}</strong></li>
          </ol>
        </div>

        {/* ✅ QR Code Container */}
        <div className="qr-code-box">
          <h4>📷 Scan to Pay Instantly:</h4>
          <img src={qrCodeImage} alt="MMG Payment QR Code" className="qr-image" />
        </div>

        <div className="receipt-upload">
          <label>📸 Upload Payment Screenshot (Optional):</label>
          <input type="file" onChange={handleFileChange} />
          {uploadedFile && <p>Selected file: {uploadedFile.name}</p>}
        </div>

        <button className="pay-button" onClick={handlePaymentConfirmation}>
          I've Completed Payment
        </button>

        <p className="mmg-note">
          ⚡ Payments are usually verified within 15 minutes during business hours.
        </p>
      </div>
    </div>
  );
};

export default MMGCheckout;
